<template>
  <MainLayout>
    <div class="container">
      <h1>Explore</h1>
      
      <div v-if="loading" class="loading">
        Loading characters...
      </div>
      
      <div v-else-if="error" class="error">
        {{ error }}
      </div>
      
      <div v-else-if="characters.length === 0" class="empty-state">
        No characters available
      </div>
      
      <div v-else class="character-grid">
        <div 
          v-for="character in characters" 
          :key="character.id" 
          class="character-card"
          @click="viewCharacter(character.id)"
        >
          <div class="character-avatar">
            <img :src="character.avatar" :alt="character.name">
          </div>
          <div class="character-info">
            <h3>{{ character.name }}</h3>
            <p>{{ character.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MainLayout from '../components/MainLayout.vue'

export default {
  name: 'Home',
  components: {
    MainLayout
  },
  computed: {
    ...mapGetters('characters', ['allCharacters', 'loading', 'error']),
    characters() {
      return this.allCharacters
    }
  },
  methods: {
    ...mapActions('characters', ['fetchCharacters']),
    viewCharacter(id) {
      this.$router.push({ name: 'CharacterDetail', params: { id } })
    }
  },
  created() {
    this.fetchCharacters()
  }
}
</script>

<style scoped>
h1 {
  margin-bottom: 20px;
  text-align: center;
}

.loading, .error, .empty-state {
  text-align: center;
  padding: 20px;
  color: var(--tg-theme-hint-color);
}

.error {
  color: #e53935;
}

.character-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.character-card {
  background-color: var(--tg-theme-bg-color);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.2s;
}

.character-card:hover {
  transform: translateY(-4px);
}

.character-avatar {
  height: 180px;
  overflow: hidden;
}

.character-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.character-info {
  padding: 16px;
}

.character-info h3 {
  margin-bottom: 8px;
}

.character-info p {
  color: var(--tg-theme-hint-color);
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style> 